var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.609 28.417q-1.815 0-3.088-1.26c-.847-.838-1.271-1.865-1.271-3.067V5.109q0-1.815 1.271-3.088Q4.793.751 6.61.75h17.82v22.513H6.61q-.773 0-1.316.524-.543.525-.543 1.3t.543 1.302 1.316.528h21.474V3.083h2.5v25.334zm4.295-7.654H21.93V3.25H10.904zm-2.5 0V3.25H6.609q-.79 0-1.325.543T4.75 5.11v16.138c.288-.137.583-.152.884-.145q.452.01.975.16h1.795Z"
  })));
};
export default SvgBook;